var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTopMyinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9586 19.9456C16.9172 21 15.2411 21 11.8889 21H10.1111C6.7589 21 5.0828 21 4.0414 19.9456C3 18.8912 3 17.1941 3 13.8V10.2C3 6.80589 3 5.10883 4.0414 4.05442C5.0828 3 6.7589 3 10.1111 3H11.8889C15.2411 3 16.9172 3 17.9586 4.05442C19 5.10883 19 6 19 7.30526",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4286,
    cy: 13.4286,
    r: 3.42857,
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7144 16.2857L21.4286 18",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.36842C6 6.88881 6.33579 6.5 6.75 6.5H13.25C13.6642 6.5 14 6.88881 14 7.36842C14 7.84804 13.6642 8.23684 13.25 8.23684H6.75C6.33579 8.23684 6 7.84804 6 7.36842ZM6 12C6 11.5204 6.33579 11.1316 6.75 11.1316H10.75C11.1642 11.1316 11.5 11.5204 11.5 12C11.5 12.4796 11.1642 12.8684 10.75 12.8684H6.75C6.33579 12.8684 6 12.4796 6 12ZM6 16.6316C6 16.152 6.33579 15.7632 6.75 15.7632H9.25C9.66421 15.7632 10 16.152 10 16.6316C10 17.1112 9.66421 17.5 9.25 17.5H6.75C6.33579 17.5 6 17.1112 6 16.6316Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTopMyinfo);
export default __webpack_public_path__ + "static/media/icon_top_myinfo.01345bedd041f6e13adb18844029f52a.svg";
export { ForwardRef as ReactComponent };